import { useEffect, useState } from 'react';

import { listChaosExperiments } from '../../../api/chaosLibraryApi';
import { listFunctionalLibrary } from '../../../api/functionalLibraryApi';
import { isSampleOnlyLibrary } from '../../onboarding/utils/onboardingDerivation';

export type ProjectDataMode = 'empty' | 'sample_only' | 'real_or_hybrid';

export const useProjectDataMode = ({
  projectId,
  chaosAllowed,
}: {
  projectId?: string;
  chaosAllowed: boolean;
}) => {
  const [projectDataMode, setProjectDataMode] =
    useState<ProjectDataMode>('empty');

  useEffect(() => {
    const loadProjectDataMode = async () => {
      if (!projectId) {
        setProjectDataMode('empty');
        return;
      }

      try {
        const [functionalLibrary, chaosLibrary] = await Promise.all([
          listFunctionalLibrary(projectId),
          chaosAllowed
            ? listChaosExperiments(projectId)
            : Promise.resolve({ data: [] }),
        ]);

        const tests = functionalLibrary.data || [];
        const hasFunctionalLibrary = tests.length > 0;
        const sampleOnlyFunctionalLibrary =
          hasFunctionalLibrary && isSampleOnlyLibrary(tests);
        const hasRealFunctionalLibrary =
          hasFunctionalLibrary && !sampleOnlyFunctionalLibrary;
        const hasChaosLibrary = (chaosLibrary.data || []).length > 0;

        if (sampleOnlyFunctionalLibrary && !hasRealFunctionalLibrary && !hasChaosLibrary) {
          setProjectDataMode('sample_only');
          return;
        }

        if (hasRealFunctionalLibrary || hasChaosLibrary) {
          setProjectDataMode('real_or_hybrid');
          return;
        }

        setProjectDataMode('empty');
      } catch {
        setProjectDataMode('empty');
      }
    };

    void loadProjectDataMode();
  }, [chaosAllowed, projectId]);

  return { projectDataMode };
};
